import { MyIntegerEnum } from './enum'

export const SolicitacaoBaixaStatus = {
  Pendente: MyIntegerEnum.create(0, 'Pendente'),
  Aprovado: MyIntegerEnum.create(1, 'Aprovado'),
  Reprovado: MyIntegerEnum.create(2, 'Reprovado'),
}
